const appConfig={
    preLoaderAnimation:{
        halt:true,
        animationOutTime:300 // in milliseconds
    }
};

export default appConfig